import DiscographyList   from '../../../pages/music/discography/List';
import DiscographyEdit   from '../../../pages/music/discography/Edit';
import DiscographyReview from '../../../pages/music/discography/Review';
import {
	getMusicDiscographyEditRoute,
	getMusicDiscographyReviewRoute,
	getMusicDiscographyRoute
}                        from './factory/discography';

/**
 * React Router v7 doesn't use 'exact' prop anymore.
 * Routes by default match 'exactly' unless there is a * or a splat parameter in the path.
 * For more details, see the React Router v7 documentation.
 */
const routes = [
	{
		path: getMusicDiscographyReviewRoute(),
		component: DiscographyReview,
		type: 'route',
		loginRequired: true,
	},
	{
		path: getMusicDiscographyEditRoute(),
		component: DiscographyEdit,
		type: 'route',
		loginRequired: true,
	},
	{
		path: getMusicDiscographyRoute(),
		component: DiscographyList,
		type: 'route',
		loginRequired: true,
	},
];

export default routes;
